import { AxiosError } from "axios";
import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { RootState } from "../../../app/store";
import { SIDEBAR_GRAPH_WIDTH } from "../../../constants/constants";
import { DataNode } from "../../../interface/Trends";
import { setLevel1Data } from "../../../utils/trendSidebarGraphUtils/colorAnalysisUtils";
import ColorAnalysisGraph from "./ColorAnalysisGraph";
import { useNavigate } from "react-router-dom";
import Dropdown from "../Dropdown";

type ColorAnalysisProps = {
  width?: number;
  trendFilterType: string;
  colorForLevel2?: string;
  setColorForLevel2?: React.Dispatch<React.SetStateAction<string>>;
  colorForLevel3?: string;
  setColorForLevel3?: React.Dispatch<React.SetStateAction<string>>;
};

const ColorAnalysisSidebar: React.FC<ColorAnalysisProps> = ({
  width = SIDEBAR_GRAPH_WIDTH,
  trendFilterType,
  colorForLevel2,
  setColorForLevel2,
  colorForLevel3,
  setColorForLevel3,
}) => {
  const [colorAnalysisData, setColorAnalysisData] = useState<DataNode | null>(
    null
  );
  const [loading, setLoading] = useState<boolean>(false);
  const user = useSelector((state: RootState) => state.user.userInfo);
  const [dataForLevel2, setDataForLevel2] = useState<DataNode | null>(null);
  const [dataForLevel3, setDataForLevel3] = useState<DataNode | null>(null);
  const navigate = useNavigate();

  const fetchColorAnalysisData = async () => {
    try {
      setLoading(true);
      await setLevel1Data(user, trendFilterType, setColorAnalysisData);
    } catch (error) {
      console.error("Error Fetching color analysis data", error);
      if ((error as AxiosError)?.response?.status !== 400) {
        toast.error("Error Fetching color analysis data");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchColorAnalysisData();
  }, [trendFilterType]);

  if (!colorAnalysisData || loading) {
    return (
      <div className="flex justify-center w-full">
        <Skeleton
          width={SIDEBAR_GRAPH_WIDTH}
          height={SIDEBAR_GRAPH_WIDTH}
          circle={true}
        />
      </div>
    );
  }

  if (
    Object.keys(colorAnalysisData).length === 0 ||
    (colorAnalysisData.children && colorAnalysisData.children.length === 0)
  ) {
    return <div className="my-5 text-center">No Color Analysis Data</div>;
  }

  return (
    <>
      <div
        className="absolute right-2 top-1 text-right text-xs underline font-bold cursor-pointer"
        onClick={() => navigate("/designer-page/color-analysis")}
      >
        Expand
      </div>
      <ColorAnalysisGraph
        data={colorAnalysisData}
        width={width}
        colorForLevel2={colorForLevel2}
        setColorForLevel2={setColorForLevel2}
        colorForLevel3={colorForLevel3}
        setColorForLevel3={setColorForLevel3}
        dataForLevel2={dataForLevel2}
        setDataForLevel2={setDataForLevel2}
        dataForLevel3={dataForLevel3}
        setDataForLevel3={setDataForLevel3}
        trendFilterType={trendFilterType}
      />
    </>
  );
};

export default ColorAnalysisSidebar;
